import {TimecodeService} from '@user-interface/glim-player';
import {AddTimecodes, ToTimeCode} from '@user-interface/timecode-utilities';
import { getFirstTimecode } from '../store/utilities/timecodes.utils';

export function getParticularTimecode(seconds, timeDisplaySource, video, fps) {
  let currentCue = TimecodeService.getCurrentTimecodeCue(video, seconds);
  if (!currentCue) {
    return {
      timecode:   estimateTimecode(seconds, timeDisplaySource, video, fps),
      isEstimate: true,
    };
  }

  if (!timeDisplaySource || timeDisplaySource.type !== 'timecode') {
    return {
      timecode:   undefined,
      isEstimate: false,
    };
  }

  let timecodes = getTimecodes(currentCue);
  let find = timecodes.find((tc) => tc.track === timeDisplaySource.name);
  return {
    timecode:   find.value,
    isEstimate: false,
  };
}

export function estimateTimecode(seconds, timeDisplaySource, video, fps) {
  const startingCue = TimecodeService.getCurrentTimecodeCue(video, 0);
  if (!startingCue) {
    return;
  }

  if (!timeDisplaySource || timeDisplaySource.type !== 'timecode') {
    return;
  }

  const timecodes = getTimecodes(startingCue);
  const firstTimecode = timecodes.find((tc) => tc.track === timeDisplaySource.name).value;

  const frames = Math.round(seconds * fps);
  const calculatedTimecode = ToTimeCode(frames, fps, firstTimecode.indexOf(';') >= 0);

  return AddTimecodes(calculatedTimecode, firstTimecode, fps);
}

export function getTimecodes(cue) {
  let timecodes = [];
  let cueData = TimecodeService.extractDataFromTimecodeCue(cue);
  TimecodeService.findAndSetTimecodes(cueData.metadata, timecodes);

  timecodes.push({
    track: 'Zero-Based Timecode',
    value: cueData.glimpseTimecode.value.split('@')[0],
  });

  return timecodes;
}

export function getTimecodeTime(timecode, videoElement,timeDisplaySource) {
  const firstTimecode = getFirstTimecode(videoElement, timeDisplaySource.name);
  if (!firstTimecode) {
    return;
  }

  return TimecodeService.timeCodeToSeconds(timecode) - TimecodeService.timeCodeToSeconds(firstTimecode);
}

export function getTimecode(timecodeCue, timeDisplaySource) {
  let timecodes = getAllTimecodes(timecodeCue);

  return timecodes.filter(timecode => {
    return timecode.track === timeDisplaySource.name
  })[0].value;
}

export function getAllTimecodes(timecodeCue) {
  let timecodes = [];
  const timecodeData = TimecodeService.extractDataFromTimecodeCue(timecodeCue);
  let metadata = timecodeData.metadata;
  let glimpseTimecode = timecodeData.glimpseTimecode;

  TimecodeService.findAndSetTimecodes(metadata, timecodes);

  timecodes.push({
    track: "Zero-Based Timecode",
    value: glimpseTimecode.value.split('@')[0]
  });
  return timecodes;
}

export function getFrameDuration(timecode) {
  const elements = timecode.split('@');
  if (elements.length !== 2) {
    return undefined;
  }

  const framerate = Number(elements[1]);
  return 1 / framerate;
}